import * as constants from './constants'

export const authVisible = activeForm => ({
    type: constants.AUTH_VISIBLE,
    activeForm,
})

export const closeAuth = () => ({
    type: constants.CLOSE_AUTH,
})

export const setHamburgerDropdownStateMain = () => ({
    type: constants.SET_HAMBURGER_DROPDOWN_STATE,
    state: constants.HAMBURGER_DROPDOWN_STATE_MAIN,
})
export const setHamburgerDropdownStateGetApp = () => ({
    type: constants.SET_HAMBURGER_DROPDOWN_STATE,
    state: constants.HAMBURGER_DROPDOWN_STATE_GET_APP,
})
export const setHamburgerDropdownStateLanguages = () => ({
    type: constants.SET_HAMBURGER_DROPDOWN_STATE,
    state: constants.HAMBURGER_DROPDOWN_STATE_LANGUAGES,
})
